import React from 'react';
import { useTranslation } from 'next-i18next';

const NegotiationListingsBuyNowButton: React.FC<{
  isProductInCart: boolean;
  onBuyNow: () => void;
  onViewCart: () => void;
}> = ({ isProductInCart, onBuyNow, onViewCart }) => {
  const { t } = useTranslation('negotiation');

  return isProductInCart ? (
    <button
      className="vc-btn vc-btn--rounded vc-btn--small"
      onClick={onViewCart}
      data-cy="negotiation_pages_cta_view_your_bag"
    >
      {t('NEGOTIATION_LISTING.OFFERS_SHARED.CTA.VIEW_YOUR_BAG')}
    </button>
  ) : (
    <button
      className="vc-btn vc-btn--rounded vc-btn--small"
      onClick={onBuyNow}
      data-cy="negotiation_pages_cta_buy_now"
    >
      {t('NEGOTIATION_LISTING.OFFERS_SHARED.CTA.BUY_NOW')}
    </button>
  );
};

export default NegotiationListingsBuyNowButton;
